import { BaseService } from './base'
import { BrowserUtility } from '../browser-utility'
import { APIPath, StorageConstant } from 'utility/constant'
import { CommonUtility } from '../common'

class Auth {
    // async checkUserExists(email) {
    //     try {
    //         const response = await BaseService.get(`${APIPath.CHECK_USER_EXISTS}?email=${email}`);
    //         return response.data.exists;
    //     } catch (error) {
    //         throw new Error('Error checking user existence');
    //     }
    // }

    login(reqData) {
        const data = CommonUtility.objectToParams(reqData)
        return BaseService.post(`${APIPath.login}?${data}`, null)
    }

    validateSocialToken(token) {
        return BaseService.post(`${APIPath.socialLogin}?Token=${token}`, null)
    }

    storeToken(token) {
        BrowserUtility.save(StorageConstant.token, token)
    }

    async saveUser(user) {
        await BrowserUtility.save(StorageConstant.user, JSON.stringify(user))
        if (user.Token) {
            await BrowserUtility.save(StorageConstant.token, user.Token)
        }
    }

    storeUser(user) {
        BrowserUtility.saveObj(StorageConstant.user, user)
    }

    getToken() {
        return BrowserUtility.get(StorageConstant.token) || ''
    }

    getUser() {
        return BrowserUtility.getObj(StorageConstant.user)
    }

    showNCReport() {
        const user = AuthService.getUser()
        return user.CompanyId === 28065
    }

    logout() {
        BrowserUtility.remove(StorageConstant.token)
    }

    register(reqData) {
        const params = {
            ...reqData,
            Source: 'Web',
            ProviderType: 0,
            ServicePlan: null,
        }

        return BaseService.post(APIPath.register, params)
    }

    forgotPassword = email => {
        return BaseService.post(
            `${APIPath.forgotPassword}?EmailAddress=${email}`,
        )
    }

    // POST Users/UpdatePassword?UserName={UserName}&OldPassword={OldPassword}&NewPassword={NewPassword}
    // URI params required; Body Parameters: None (per API Help page)
    updatePassword({ UserName, OldPassword, NewPassword }) {
        const query = [
            `UserName=${encodeURIComponent(UserName)}`,
            `OldPassword=${encodeURIComponent(OldPassword)}`,
            `NewPassword=${encodeURIComponent(NewPassword)}`,
        ].join('&')
        return BaseService.postNoBody(`${APIPath.updatePassword}?${query}`)
    }

    isAuthenticated() {
        const token = this.getToken()
        return !!token
    }
}

const AuthService = new Auth()
Object.freeze(AuthService)
export { AuthService }
